import React from "react";
import { Layout } from "../index";

interface IPageNotFoundProps {
  message?: string;
  needLayout?: boolean;
}

export const PageNotFound = ({
  message,
  needLayout = false,
}: IPageNotFoundProps) => {
  const content = <h1>{message ? message : "Страница не найдена"}</h1>;

  if (needLayout) {
    return <Layout>{content}</Layout>;
  } else {
    return content;
  }
};
